/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Limit_3_ValueInputs */

const en_svc_n8n_limit_3_value = /** @type {(inputs: Svc_N8n_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The workflows and accounts are yours, on your own instance.`)
};

const lv_svc_n8n_limit_3_value = /** @type {(inputs: Svc_N8n_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darba plūsmas un konti pieder Jums un darbojas Jūsu pašu n8n vidē.`)
};

/**
* | output |
* | --- |
* | "The workflows and accounts are yours, on your own instance." |
*
* @param {Svc_N8n_Limit_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_limit_3_value = /** @type {((inputs?: Svc_N8n_Limit_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Limit_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_limit_3_value(inputs)
	return en_svc_n8n_limit_3_value(inputs)
});